export default "__VITE_ASSET__CPPNeWz___"